module.exports = {
          srcSet: "/assets/images/5d30cf05abb1c33182baaa220a5ec32f-133.png"+" 133w",
          images:[ {path: "/assets/images/5d30cf05abb1c33182baaa220a5ec32f-133.png",width: 133,height: 22}],
          src: "/assets/images/5d30cf05abb1c33182baaa220a5ec32f-133.png",
          toString:function(){return "/assets/images/5d30cf05abb1c33182baaa220a5ec32f-133.png"},
          placeholder: undefined,
          width: 133,
          height: 22
      }